const cache = new Map();

export function prefetch(key, fetchFn) {
  if (cache.has(key)) return cache.get(key);
  const promise = fetchFn().catch(err => {
    cache.delete(key);
    throw err;
  });
  cache.set(key, promise);
  return promise;
}

export function getCached(key) {
  return cache.get(key) || null;
}

export function invalidate(key) {
  cache.delete(key);
}

export function invalidateForUser(uid) {
  for (const key of cache.keys()) {
    if (key.includes(uid)) cache.delete(key);
  }
}

export function invalidateAll() {
  cache.clear();
}
